import { render } from "./AccountProfileView.vue?vue&type=template&id=e0081f44"
import script from "./AccountProfileView.vue?vue&type=script&lang=js"
export * from "./AccountProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__